import React from 'react';
import { useField } from 'formik';
import { Form, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';

import history from 'browserHistory';
import { FormGroupFieldProps } from '../types';
import styles from '../Input/Input.module.scss';

type Props = {
  isInvalid: boolean;
  markButtons?: any;
  isFocus?: boolean;
  isRequired?: boolean;
  isRequiredAtStart?: boolean;
  growth?: boolean;
};

const Group: React.FC<Props & FormGroupFieldProps> = ({
  onLine = false,
  isInvalid,
  markButtons,
  growth,
  label,
  error,
  isFocus = false,
  isRequired = false,
  isRequiredAtStart = false,
  children,
  ...props
}) => {
  const [, { error: fieldError }] = useField(props);
  // const requiredMark = isRequired ? <em className="text-danger position-absolute end-0">*</em> : '';
  const requiredMarkLabel = isRequiredAtStart ? <em className="text-danger mx-1">*</em> : '';
  const requiredMarkTolMessage = props.name === 'toleranceMessage' ? <span className="text-danger mx-1">*</span> : '';
  const isGlobal = history.location.pathname.includes('globaladmin');

  return (
    <Form.Group {...props} className="w-100">
      {onLine ? (
        <div className={classNames({ row: !!label || !!markButtons }, props.className, 'flex-nowrap')}>
          {!!label && (
            <Form.Label className={`d-flex col-${isGlobal ? '4' : '3'}`}>
              <span>
                {label} {requiredMarkTolMessage}:
              </span>
            </Form.Label>
          )}
          {growth ? (
            <div className="d-flex flex-column position-relative">
              <div
                className={classNames('d-flex flex-row w-100 justify-content-end', {
                  [styles.inputOptMark]: isRequired,
                })}
              >
                {children}
              </div>
              {isFocus && (
                <Form.Control.Feedback tooltip className={classNames({ 'd-block': isInvalid })} type="invalid">
                  {!!error && fieldError}
                </Form.Control.Feedback>
              )}
            </div>
          ) : (
            <div className="d-flex flex-column flex-grow-1 position-relative">
              <div
                className={classNames('d-flex flex-row w-100 justify-content-end', {
                  [styles.inputOptMark]: isRequired,
                })}
              >
                {children}
              </div>
              {isFocus && (
                <Form.Control.Feedback tooltip className={classNames({ 'd-block': isInvalid })} type="invalid">
                  {!!error && fieldError}
                </Form.Control.Feedback>
              )}
            </div>
          )}
          {markButtons}
        </div>
      ) : (
        <Row>
          {!!label && (
            <Col className="d-flex align-items-center" xs={4}>
              <Form.Label className="mr-5">
                {label} {requiredMarkLabel}:
              </Form.Label>
            </Col>
          )}
          {/* eslint-disable-next-line */}
          <Col xs={!!label ? 5 : 9} className={!!label ? '' : 'pr-3'}>
            <div className={classNames('d-flex position-relative w-100', { [styles.inputOptMark]: isRequired })}>
              {children}
            </div>
            {isFocus && (
              <Form.Control.Feedback tooltip className={classNames({ 'd-block': isInvalid })} type="invalid">
                {!!error && fieldError}
              </Form.Control.Feedback>
            )}
          </Col>
          <Col xs={3} className="pl-5 position-relative">
            {markButtons}
          </Col>
        </Row>
      )}
    </Form.Group>
  );
};

export default Group;
